import script from "./MyCatalogDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MyCatalogDetails.vue?vue&type=script&setup=true&lang=js"

import "./MyCatalogDetails.vue?vue&type=style&index=0&id=e0a75844&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0a75844"]])

export default __exports__
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerDots,QBanner,QBtn,QIcon,QBadge,QDialog,QCard,QBar,QSpace,QCardSection,QCarousel,QCarouselSlide});qInstall(script, 'directives', {ClosePopup});
